// @flow
import React from 'react';
import { Redirect } from 'react-router-dom';
import { prefixRoutes } from 'metaup/routing/routingUtils';
import { offlineTokensListPageRoutes } from './OfflineTokensListPage';
import { offlineTokenCreatePageRoutes } from './OfflineTokenCreatePage';
import { offlineBranchesPageRoutes } from './OfflineBranchesPage';
import { offlineCutsPageRoutes } from './OfflineCutsPage';

// Раздел переехал с /offline-tokens/ на /offline/, старые адреса оставлены
// редиректами: они разосланы в закладках.
function legacyRedirects() {
  return [
    {
      title: 'Офлайн-каттер',
      path: '/offline-tokens/',
      isEnabled: ({ isUser }) => isUser,
      render: () => <Redirect to="/offline/tokens/" />,
      design: null,
    },
    {
      title: 'Офлайн-каттер',
      path: '/offline-tokens/create/',
      isEnabled: ({ isUser }) => isUser,
      render: () => <Redirect to="/offline/tokens/create/" />,
      design: null,
    },
  ];
}

export function offlineTokensRoutes() {
  return prefixRoutes('/', [
    ...offlineBranchesPageRoutes(),
    ...offlineCutsPageRoutes(),
    ...offlineTokensListPageRoutes(),
    ...offlineTokenCreatePageRoutes(),
    ...legacyRedirects(),
  ]);
}
